import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'
import { getErrorMessage } from '@fortem-monorepo/web-sdk'

import { useDeleteFundHolidayMutation } from '@/react-query/mutations/funds'

export type HolidayToDelete = { id: string; date: string; fundName: string }

export const DeleteFundHolidayDialog = ({ holiday, onClose }: { holiday: HolidayToDelete; onClose: () => void }) => {
  const mutation = useDeleteFundHolidayMutation()
  return (
    <Dialog open onOpenChange={(open) => !open && !mutation.isPending && onClose()}>
      <DialogContent onEscapeKeyDown={(event) => mutation.isPending && event.preventDefault()}>
        <DialogHeader>
          <DialogTitle>
            Delete {holiday.date} Holidays for {holiday.fundName}?
          </DialogTitle>
          <DialogDescription>This permanently deletes this holiday entry. Confirm to continue.</DialogDescription>
        </DialogHeader>
        {mutation.isError && (
          <p role="alert" className="text-sm text-destructive">
            {getErrorMessage(mutation.error)}
          </p>
        )}
        <DialogFooter>
          <Button size="sm" variant="outline" disabled={mutation.isPending} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            variant="destructive"
            disabled={mutation.isPending}
            onClick={() => mutation.mutate(holiday.id, { onSuccess: onClose })}
          >
            {mutation.isPending ? 'Deleting...' : 'Confirm delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
